var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/PositionEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { dynamicSort } from '@/core/helpers/table-sort';
import { splitIntoChunk } from '@/core/helpers/array';
import { IPositionForm } from '@/core/types/entities/hrgs/master/PositionEntities';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/positions`
};
let PositionModule = class PositionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.schemaList = [];
        this.loading = false;
        this.schemaListPagination = [];
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
    }
    // *GETTERS
    get getPositionList() {
        return this.schemaList;
    }
    get getPositionListLoading() {
        return this.loading;
    }
    get getPositionListPagination() {
        return {
            data: this.schemaListPagination,
            pagination: this.pagination
        };
    }
    // *MUTATIONS
    [_a = Mutations.SET_POSITION_LIST](data) {
        this.schemaList = data;
    }
    [_b = Mutations.SET_POSITION_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_POSITION_LIST_PAGINATION](data) {
        const paginated = splitIntoChunk(this.schemaList, data.pageSize);
        this.schemaListPagination = paginated[data.currentPage - 1];
        this.pagination = {
            totalPage: this.schemaList.length,
            totalPageSize: data.pageSize || this.pagination.totalPageSize,
            startPaginationIndex: 0,
            endPaginationIndex: paginated.length - 1,
            currentPage: data.currentPage || this.pagination.currentPage
        };
    }
    // *start: ACTION
    [_d = Actions.GET_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_POSITION_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content.sort(dynamicSort('name', 'descending'));
                this.context.commit(Mutations.SET_POSITION_LIST, resData);
                this.context.commit(Mutations.SET_POSITION_LIST_PAGINATION, {
                    currentPage: 1,
                    pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || 10
                });
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_POSITION_LIST_LOADING, false);
            });
        });
    }
    [_e = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_f = Actions.POST_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                reject(_response);
            });
        });
    }
    [_g = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                reject(_response);
            });
        });
    }
    [_h = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    reject();
                }
                this.context.dispatch(Actions.GET_LIST);
                resolve(res.data.statusCode);
            })
                .catch((response) => {
                reject(response);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _d, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_j = typeof IPositionForm !== "undefined" && IPositionForm) === "function" ? _j : Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PositionModule.prototype, _h, null);
PositionModule = __decorate([
    Module
], PositionModule);
export default PositionModule;
